import { Injectable, OnDestroy } from '@angular/core';
import { navigationConfig, NavigationMenuItem } from './navigation.config';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService implements OnDestroy {
  public isNavigationMenuOpen = false;

  public navigationMenuItems: Record<string, NavigationMenuItem> =
    navigationConfig.coachee;

  private navigationEndSubscription: Subscription;

  constructor(private readonly router: Router) {
    this.navigationEndSubscription = router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isNavigationMenuOpen = false;
      }
    });
  }

  toggleNavigationMenu() {
    this.isNavigationMenuOpen = !this.isNavigationMenuOpen;
  }

  ngOnDestroy(): void {
    this.navigationEndSubscription.unsubscribe();
  }
}
